<template>
  <v-container pa-0 fill-height>
    <v-btn v-if="id != ''" text small @click="onClick">
      <v-icon left small>mdi-account</v-icon>
      {{ label }}
    </v-btn>
    <span v-else>
      <v-icon left small>mdi-account</v-icon>
      {{ label }}
    </span>
  </v-container>
</template>

<script>
export default {
  name: "client-label",
  props: {
    value: {
      type: String,
      defaule: () => "Client Name",
    },
    clientId: {
      type: String,
      default: () => "",
    },
  },

  computed: {
    label() {
      return this.params
        ? this.params.data.itinerary && this.params.data.itinerary.clientName
          ? this.params.data.itinerary.clientName
          : this.params.data.clientName
        : this.value;
    },
    id() {
      return this.params
        ? this.params.data.itinerary && this.params.data.itinerary.client
          ? this.params.data.itinerary.client.id
          : this.params.data.client
          ? this.params.data.client.id
          : ""
        : this.clientId;
    },
  },

  methods: {
    onClick() {
      this.$router.push(`/client/${this.id}/edit`);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/labels/ClientLabel.vue